import { chains } from "@sablier/v2-constants";
import { _ } from "@sablier/v2-mixins";

type Props = {
  chainId?: (typeof chains)[string]["chainId"];
};

export function getEndpointByChain({ chainId }: Props): string | undefined {
  if (_.isNilOrEmptyString(chainId)) {
    return undefined;
  }

  const chain = Object.values(chains).find(
    (chain) => chain.chainId === chainId,
  );

  if (_.isNil(chain)) {
    return undefined;
  }

  return chain.subgraph();
}
